import React from 'react';

const Navbar = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 py-3">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_young-tech-careers/artifacts/rfv9wrv7_original-B1BE815D-C806-43C2-B76A-E4E1916083E4.jpeg"
              alt="The 317 Foundation"
              className="h-14 w-auto object-contain"
            />
            <div className="border-l border-gray-300 pl-3 hidden sm:block">
              <div className="text-xs text-gray-600 italic">Bridging You to the Future You Deserve..</div>
            </div>
          </div>
          
          {/* Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('about')} 
              className="text-gray-600 hover:text-gray-900 font-medium transition-colors"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('courses')} 
              className="text-gray-600 hover:text-gray-900 font-medium transition-colors"
            >
              Courses
            </button>
            <button 
              onClick={() => scrollToSection('contact')} 
              className="text-gray-600 hover:text-gray-900 font-medium transition-colors"
            >
              Contact
            </button>
            <button 
              onClick={() => scrollToSection('contact')} 
              className="btn-primary"
            >
              Apply Now
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;